export default {
  ADMIN: 'PVF_TINTIN_1',
  ADMIN_STAGING: 'PVF_TINTIN_2',
  NEWSLETTER_VIEW: 'PVF_TINTIN_100',
  NEWSLETTER_CREATE: 'PVF_TINTIN_101',
  NEWSLETTER_EDIT: 'PVF_TINTIN_102',
  TEMPLATE_VIEW: 'PVF_TINTIN_200',
  TEMPLATE_CREATE: 'PVF_TINTIN_201',
  TEMPLATE_EDIT: 'PVF_TINTIN_202',
  CAMPAIGN_VIEW: 'PVF_TINTIN_300',
  CAMPAIGN_CREATE: 'PVF_TINTIN_301',
  CAMPAIGN_EDIT: 'PVF_TINTIN_302',
  CAMPAIGN_PUBLISH: 'PVF_TINTIN_304',
  AD_EDIT: 'PVF_TINTIN_401',
  NEWS_GROUP: 'PVF_TINTIN_500',
  OPINION_GROUP: 'PVF_TINTIN_501',
}
